var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"article-list"},_vm._l((_vm.list),function(item,key){return _c('ListArticleItem',_vm._b({key:key,attrs:{"thumb-style":_vm.thumbStyle}},'ListArticleItem',item,false))}),1)}
var staticRenderFns = []

export { render, staticRenderFns }